<template>
  <el-dialog
    :visible="visible"
    title="Add File to Knowledge Base"
    width="600px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="mb-3">
      <p>
        <small>
          <i
            >Supported formats: {{ supportedFormatsText }}. Max file size:
            50MB.</i
          >
        </small>
      </p>
    </div>
    <multi-upload
      v-if="bot.id"
      :action="getAction"
      :delete-action="deleteAction"
      :showFileList="false"
      :disabled="loading"
      :accept="acceptedFileTypes"
      :max-file-size="maxFileSize"
      :allowed-extensions="allowedExtensions"
      :pre-upload-hook="prepareKnowledgeBase"
      @success="successFileUpload"
      @failed="failedFileUpload"
      @before-upload="beforeFileUpload"
    />
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">Close</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MultiUpload from '../../multi-upload.vue'
import * as AloAi from '../../../constants/aloai'

export default {
  name: 'AddFileModal',

  components: {
    MultiUpload
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    bot: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      loading: false,
      maxFileSize: 50 * 1024 * 1024,
      prepareUploadPromise: null
    }
  },

  watch: {
    visible(newVal) {
      if (!newVal) {
        this.loading = false
        this.prepareUploadPromise = null
      }
    }
  },

  computed: {
    allowedExtensions() {
      if (this.bot.type === AloAi.TYPE_TEXT) {
        return [
          'c',
          'cpp',
          'cs',
          'css',
          'doc',
          'docx',
          'go',
          'html',
          'java',
          'js',
          'json',
          'md',
          'pdf',
          'php',
          'pptx',
          'py',
          'rb',
          'sh',
          'tex',
          'ts',
          'txt'
        ]
      }

      return [
        'bmp',
        'csv',
        'doc',
        'docx',
        'eml',
        'epub',
        'heic',
        'html',
        'jpeg',
        'jpg',
        'png',
        'md',
        'msg',
        'odt',
        'org',
        'p7s',
        'pdf',
        'ppt',
        'pptx',
        'rst',
        'rtf',
        'tiff',
        'txt',
        'tsv',
        'xls',
        'xlsx',
        'xml'
      ]
    },

    supportedFormatsText() {
      return this.allowedExtensions.join(', ')
    },

    getAction() {
      return '/api/v1/aloai/bot/' + this.bot.id + '/add-file'
    },

    deleteAction() {
      return '/api/v1/aloai/bot/' + this.bot.id + '/delete-content'
    },

    acceptedFileTypes() {
      return this.allowedExtensions.map((ext) => '.' + ext).join(',')
    }
  },

  methods: {
    handleClose() {
      this.$emit('close')
    },

    successFileUpload() {
      this.loading = false
      this.$emit('success')
      this.handleClose()
    },

    failedFileUpload() {
      this.loading = false
      this.$emit('failed')
    },

    beforeFileUpload() {
      this.loading = true
      this.$emit('before-upload')
    },

    prepareKnowledgeBase() {
      if (!this.prepareUploadPromise) {
        this.loading = true

        this.prepareUploadPromise = axios
          .post('/api/v1/aloai/bot/' + this.bot.id + '/prepare-upload')
          .catch((error) => {
            this.loading = false
            this.prepareUploadPromise = null

            this.$notify({
              offset: 95,
              title: 'Error',
              message: 'Failed to prepare knowledge base for upload.',
              type: 'error',
              showClose: true
            })

            throw error
          })
      }

      return this.prepareUploadPromise
    }
  }
}
</script>
